module.exports = __webpack_public_path__ + "img/ccompany-honor-TPD-20230721.a9def229.jpg";